import React from 'react';
import styles from './Footer.module.scss';
import { useAppContext } from '@/context/AppContext';
import { Language } from '@/types';

const Footer: React.FC = () => {
  const { language } = useAppContext();
  const year = new Date().getFullYear();

  const rightsText =
    language === Language.EN
      ? 'All rights reserved.'
      : 'Todos os direitos reservados.';

  return (
    <footer className={`${styles.footer} footerSection`} id="footer" aria-label="Site footer">
      <div className={styles.inner}>
        <div className={styles.content}>© {year} {rightsText}</div>
      </div>
    </footer>
  );
};

Footer.displayName = 'Footer';
export default Footer;


